import { TypographyOptions } from '@mui/material/styles/createTypography';

import { pxToRem, responsiveFontSizes } from '@src/utils/typography';

const primaryFont = 'Manrope, sans-serif';
const secondaryFont = 'Oxanium, sans-serif';

const typography: TypographyOptions = {
  fontFamily: primaryFont,
  secondaryFontFamily: secondaryFont,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: secondaryFont,
    fontWeight: 500,
    lineHeight: 1.44444,
    fontSize: pxToRem(20.25),
    ...responsiveFontSizes({ sm: 29.25, md: 32.62, lg: 36 }),
  },
  h2: {
    fontWeight: 500,
    lineHeight: 1.35,
    fontSize: pxToRem(28.8),
    ...responsiveFontSizes({ sm: 22.5, md: 24.75, lg: 28.8 }),
  },
  h3: {
    fontWeight: 500,
    lineHeight: 1.4,
    fontSize: pxToRem(21.6),
    ...responsiveFontSizes({ sm: 14.625, md: 16.875, lg: 21.6 }),
  },
  h4: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 11.25, md: 11.25, lg: 18 }),
  },
  h5: {
    fontWeight: 500,
    lineHeight: 1.4,
    fontSize: pxToRem(16.2),
    ...responsiveFontSizes({ sm: 10.6875, md: 11.25, lg: 16.2 }),
  },
  h6: {
    fontWeight: 500,
    lineHeight: 1.4,
    fontSize: pxToRem(15.3),
    ...responsiveFontSizes({ sm: 10.125, md: 10.125, lg: 15.3 }),
  },
  subtitle1: {
    fontFamily: secondaryFont,
    fontWeight: 500,
    lineHeight: 36 / 24,
    fontSize: pxToRem(24),
  },
  subtitle2: {
    fontFamily: secondaryFont,
    fontWeight: 500,
    lineHeight: 22 / 18,
    fontSize: pxToRem(18),
  },
  body1: {
    fontWeight: 500,
    lineHeight: 22 / 16,
    fontSize: pxToRem(16),
  },
  body2: {
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  button: {
    fontFamily: secondaryFont,
    fontWeight: 600,
    lineHeight: 20 / 14,
    fontSize: pxToRem(14),
    textTransform: 'none',
  },
};

export default typography;
